export default __webpack_public_path__ + "static/media/ag_7.3cedf22e.wav";